export default {
  isLoading(state) {
    return state.locationBreakdownLoading;
  },
  getStateRegionSubregionOptions(state) {
    return state.stateRegionSubregionOptions;
  },
};
